import { useApi } from "../../lib/api";
import { SectionHead, SourceTag } from "../Badges";

const LIGHT = { green: ["#38A169", "Healthy"], amber: ["#DD6B20", "Watch"], red: ["#E53E3E", "Alert"] };

export const PulseGauge = ({ s, testId = "sentiment-pulse" }) => {
  const [c, l] = LIGHT[s?.status] || ["#4A5568", "—"];
  const total = s?.analysed || 0;
  const pct = (k) => (total ? Math.round(((s.counts[k] || 0) / total) * 100) : 0);
  return (
    <div data-testid={testId}>
      <div className="flex items-end gap-4">
        <div className="font-data text-6xl font-bold" style={{ color: c }} data-testid="sentiment-index">{s ? (s.index > 0 ? "+" : "") + s.index : "—"}</div>
        <div className="pb-2">
          <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full" style={{ background: c, boxShadow: `0 0 16px ${c}` }} /><span className="font-data text-xs uppercase tracking-widest" style={{ color: c }}>{l}</span></div>
          <div className="text-xs text-slate-500 mt-1">{total} items analysed</div>
        </div>
      </div>
      <div className="flex h-2 mt-5 rounded-full overflow-hidden bg-slate-800">
        <div style={{ width: `${pct("positive")}%` }} className="bg-green-500" />
        <div style={{ width: `${pct("neutral")}%` }} className="bg-slate-500" />
        <div style={{ width: `${pct("negative")}%` }} className="bg-red-500" />
      </div>
      <div className="flex justify-between font-data text-[10px] mt-2 text-slate-400">
        <span>POS {pct("positive")}%</span><span>NEU {pct("neutral")}%</span><span>NEG {pct("negative")}%</span>
      </div>
    </div>
  );
};

const ThemeList = ({ title, items, tone }) => (
  <div>
    <div className={`eyebrow mb-3 ${tone}`}>{title}</div>
    <ul className="space-y-2">
      {(items || []).map((t, i) => (
        <li key={i}><a href={t.url} target="_blank" rel="noreferrer" className="text-sm text-slate-200 hover:text-[color:var(--gold)] transition-colors">{t.theme ? <span className="text-slate-500">{t.theme} — </span> : null}{t.title}</a></li>
      ))}
      {items?.length === 0 && <li className="text-xs text-slate-500">Not found in current window</li>}
    </ul>
  </div>
);

export const SentimentPanel = () => {
  const { data: s } = useApi("/public/sentiment");
  return (
    <section id="pulse" className="relative grain bg-[#F4F8F5] border-y border-[color:var(--line)]" data-testid="pulse-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 grid lg:grid-cols-3 gap-10">
        <div>
          <SectionHead eyebrow="What Ghana is saying" title="Today's public pulse" />
          <PulseGauge s={s} />
          <p className="text-xs text-slate-500 mt-6">{s?.engine}</p>
          <p className="text-xs text-slate-500 mt-2">{s?.source}</p>
          <div className="mt-3"><SourceTag source="Peacefmonline.com" url="https://www.peacefmonline.com" /></div>
        </div>
        <div className="lg:col-span-2 grid md:grid-cols-2 gap-8">
          <ThemeList title="Top positive themes" items={s?.top_positive} tone="!text-green-400" />
          <ThemeList title="Top concerns" items={s?.top_concerns} tone="!text-red-400" />
        </div>
      </div>
    </section>
  );
};
